import * as React from "react";
import s from "./DropDown.module.scss";
import {
  DropDownList,
  DropDownListProps,
} from "@progress/kendo-react-dropdowns";
import cn from "classnames";

interface IProps extends DropDownListProps {
  illioInputProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >;
}

export const DropDown = ({
  className,
  illioInputProps,
  popupSettings,
  ...rest
}: IProps) => {
  return (
    <div className={"illio-input"} {...illioInputProps}>
      <DropDownList
        popupSettings={{
          popupClass: "illio-combo",
          ...popupSettings,
          appendTo: document.getElementById("app"),
        }}
        className={cn(s.dropDown, className)}
        {...rest}
      />
    </div>
  );
};

export default DropDown;
